<template>
    <div class='main'>
        <el-tabs v-model='activeName'>
            <el-tab-pane label='安全' name='security'>
                <el-form label-position='left'>
                    <el-form-item label='允许客户端创建Class'>
                        <el-switch
                            v-model='applicationSystemConfig.allowClientCreateClass'
                            active-color='#13ce66'
                            @change='updateSwitchConfig($event, "allowClientCreateClass")'
                            inactive-color='#ff4949'>
                        </el-switch>
                    </el-form-item>
                    
                    <el-form-item label='允许自定义ObjectId'>
                        <el-switch
                            v-model='applicationSystemConfig.allowCustomObjectId'
                            active-color='#13ce66'
                            @change='updateSwitchConfig($event, "allowCustomObjectId")'
                            inactive-color='#ff4949'>
                        </el-switch>
                    </el-form-item>
                    
                    <el-form-item label='upsert'>
                        <el-tooltip class='item' effect='dark'
                                    content='如果打开，则执行修改操作时，如果ObjectId不存在，会自动执行创建Class操作'
                                    placement='top-start'>
                            <span style='margin-right: 1rem' class='el-icon-warning-outline' />
                        </el-tooltip>
                        <el-switch
                            v-model='applicationSystemConfig.upsert'
                            active-color='#13ce66'
                            @change='updateSwitchConfig($event, "upsert")'
                            inactive-color='#ff4949'>
                        </el-switch>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label='自定义配置' name='custom'>
                <vue-json-pretty :data='applicationSystemConfig.applicationInfo' />
                
                <div style='margin-top: 2rem'>
                    <el-button style='float: left' type='primary' @click='handleAddCustomConfig()'>新增或修改
                    </el-button>
                </div>
            </el-tab-pane>
            
            <el-tab-pane label='权限' name='access'>
                <el-card class='box-card'>
                    <div slot='header' class='clearfix'>
                        <span>默认Class访问权限</span>
                    </div>
                    <class-acl :app-id='queryParams.appId'
                               :show-button-group='true'
                               :show-authenticated-user-setting='true'
                               @getAccessInfo='handleGetDefaultCLPInfo'
                               @cancelAccessInfoSetting='handleCancelSetCLPInfo'
                               :all-access-info='accessInfo' />
                </el-card>
            </el-tab-pane>
        </el-tabs>
        
        <el-dialog title='自定义应用配置' :visible.sync='openAddCustomConfig' width='40%' @close='cancel'>
            <div>
                <el-input
                    type='textarea'
                    :rows='10'
                    placeholder='请输入自定义的应用配置'
                    v-model='customConfigText'>
                </el-input>
            </div>
            
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='submitCustomConfig'>保 存</el-button>
                <el-button @click='openAddCustomConfig = false'>取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { trackReportSettingApi } from '@api/Track/trackReportSetting';
import { message } from '@/utils/message';
import TrackEventChart from '@view/track/analyse/component/TrackEventChart.vue';
import { applicationConfigApi } from '@api/Storage/applicaitonConfig';
import VueJsonPretty from 'vue-json-pretty';
import { deepCopy } from '@/utils/object';
import ClassAcl from '@/components/component/storage/ClassAcl.vue';

export default {
    name: 'User',
    components: { ClassAcl, VueJsonPretty, TrackEventChart },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                appId: undefined
            },
            
            activeName: 'security',
            applicationSystemConfig: {},
            openAddCustomConfig: false,
            
            customConfigText: undefined,
            accessInfo: {}
            
        };
    },
    watch: {},
    created() {
        this.setInitValue();
        this.initData();
    },
    beforeDestroy() {
    
    },
    methods: {
        setInitValue() {
            this.queryParams.appId = undefined;
            if (this.$route.params.appId && this.$route.params.appId.indexOf('undefined') === -1) {
                this.queryParams.appId = this.$route.params.appId;
            }
            if (!this.queryParams.appId) {
                message.error('请选择应用!');
                this.$router.push(`/storage-application`);
                return;
            }
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        initData() {
        
        
        },
        getList() {
            this.applicationSystemConfig = {};
            applicationConfigApi.queryConfigList(this.queryParams.appId).then(result => {
                if (result.code === 200) {
                    let data = result.data;
                    this.applicationSystemConfig = data.system;
                    if (!this.applicationSystemConfig.applicationInfo) {
                        this.applicationSystemConfig.applicationInfo = {};
                    }
                    this.accessInfo = deepCopy(this.applicationSystemConfig.default_clp);
                }
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                eventId: undefined,
                projectAppId: this.queryParams.projectAppId,
                name: undefined
            };
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '新增事件分析';
            this.updateStatus = false;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentReportSetting = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件报表设置';
            this.setReportSettingParam(row);
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this;
            this.$modal.confirm('是否确认删除"' + row.name + '"的数据项？').then(function() {
                return trackReportSettingApi.deleteData(row);
            }).then((result) => {
                if (result.code === 200) {
                    message.success(result.message);
                    obj.getList();
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
        
        },
        submitCustomConfig: function() {
            this.applicationSystemConfig.applicationInfo = JSON.parse(this.customConfigText);
            this.saveConfig('applicationInfo', this.applicationSystemConfig.applicationInfo);
            this.openAddCustomConfig = false;
        },
        saveConfig(key, value) {
            let data = {
                key: key,
                value: value
            };
            applicationConfigApi.updateConfig(data, this.queryParams.appId).then(result => {
                if (result.code === 200) {
                    message.success(result.message);
                } else {
                    message.error(result.message);
                }
            });
        },
        cancelCustomConfig() {
            this.openAddCustomConfig = false;
        },
        handleAddCustomConfig() {
            this.openAddCustomConfig = true;
            if (this.applicationSystemConfig.applicationInfo) {
                this.customConfigText = JSON.stringify(deepCopy(this.applicationSystemConfig.applicationInfo), null, 2);
            }
        },
        
        updateSwitchConfig(value, key) {
            this.saveConfig(key, value);
        },
        
        handleGetDefaultCLPInfo(accessInfo) {
            this.saveConfig('default_clp', accessInfo);
        },
        handleCancelSetCLPInfo() {
            this.accessInfo = deepCopy(this.applicationSystemConfig.default_clp);
        }
        
    }
};
</script>
<style lang='css'>

</style>
